"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.sendImmediateRequest = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _constants = require("./constants");

var _logger = _interopRequireDefault(require("./utils/logger"));

var _misc = require("./utils/misc");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cycleRequest = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var url, options, data, retries, retriesRemaining, delay, response, method, withCredentials, headers;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, options = _ref.options, data = _ref.data, retries = _ref.retries, retriesRemaining = _ref.retriesRemaining, delay = _ref.delay;
            _context.prev = 1;
            // Attempt a send:
            method = data ? 'post' : 'get';
            withCredentials = options.withCredentials === false ? false : true;
            headers = options.headers ? options.headers : {};
            _context.next = 7;
            return (0, _axios["default"])({
              method: method,
              url: url,
              data: data,
              withCredentials: withCredentials,
              headers: headers
            });

          case 7:
            response = _context.sent;
            _context.next = 15;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            _context.next = 14;
            return tryAgain({
              retries: retries,
              retriesRemaining: retriesRemaining,
              delay: delay,
              url: url,
              options: options,
              data: data,
              error: _context.t0
            });

          case 14:
            response = _context.sent;

          case 15:
            return _context.abrupt("return", response);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function cycleRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // This differs from the sendRequest method in the following ways
// 1.) it will keep the request alive after navigating away
// 2.) it won't continually retry events
// This is meant to imitate the functionality of the sendBeacon, with better support for options
// This api is used when events are flushed from cache (eg. when navigating away from the page)


var sendImmediateRequest = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var url, data, _ref3$options, options, headers, withCredentials;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = _ref3.url, data = _ref3.data, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options;
            headers = _objectSpread({
              'content-type': 'application/json;charset=UTF-8'
            }, options.headers);
            withCredentials = options.withCredentials === false ? false : true;
            _context2.prev = 3;
            return _context2.abrupt("return", fetch(url, {
              method: 'POST',
              headers: headers,
              keepalive: true,
              credentials: withCredentials ? 'include' : 'same-origin',
              body: JSON.stringify(data)
            }));

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", (0, _axios["default"])({
              method: 'POST',
              headers: headers,
              url: url,
              data: data,
              withCredentials: true
            }));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 7]]);
  }));

  return function sendImmediateRequest(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.sendImmediateRequest = sendImmediateRequest;

var setSlowResponseDetection = function setSlowResponseDetection(url) {
  return setTimeout(function () {
    // Send an error if the request takes too long:
    _logger["default"].log(new Error("Request to ".concat(url, " took greater than ").concat(_constants.SLOW_RESPONSE_THRESHOLD, " to complete")));
  }, _constants.SLOW_RESPONSE_THRESHOLD);
};

var sendRequest = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref5) {
    var url, data, retries, _ref5$options, options, timeoutId, response;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = _ref5.url, data = _ref5.data, retries = _ref5.retries, _ref5$options = _ref5.options, options = _ref5$options === void 0 ? {} : _ref5$options;
            // Start countdown till error for slow response:
            timeoutId = setSlowResponseDetection(url); // Send data to backend:

            _context3.next = 4;
            return cycleRequest({
              url: url,
              data: data,
              options: options,
              retries: retries,
              retriesRemaining: retries,
              delay: _constants.DELAY_BETWEEN_RETRIES
            });

          case 4:
            response = _context3.sent;
            // Clear countdown till error from slow response:
            clearTimeout(timeoutId);
            return _context3.abrupt("return", response);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function sendRequest(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var tryAgain = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref7) {
    var retries, retriesRemaining, delay, url, options, data, error, newRetriesRemaining;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            retries = _ref7.retries, retriesRemaining = _ref7.retriesRemaining, delay = _ref7.delay, url = _ref7.url, options = _ref7.options, data = _ref7.data, error = _ref7.error;

            // If the request failed, error then continue trying till success or retries are exhausted.
            if (retriesRemaining === retries) {
              // To avoid too much noise if all of the retries fail, we'll only throw an error the first time and the last time.
              error.message = "RSW's first request to ".concat(url, " failed. Retrying. ").concat(error.message);

              _logger["default"].log(error);
            }

            if (retriesRemaining === retries - 1 && retriesRemaining !== 0) {
              // Request failed consecutively.  This should be logged to error handler
              error.message = "RSW request to ".concat(url, " failed twice in a row. Will continue to retry");

              _logger["default"].error(error);
            }

            if (!(retriesRemaining === 0)) {
              _context4.next = 7;
              break;
            }

            // We have exhausted our retries.  Give up and alert the error:
            error.message = "RSW request to ".concat(url, " failed all ").concat(retries, " retries. ").concat(error.message);

            _logger["default"].error(error);

            return _context4.abrupt("return", error);

          case 7:
            // Decrement retry counter, wait for a bit, then try again:
            newRetriesRemaining = retriesRemaining - 1;
            return _context4.abrupt("return", (0, _misc.wrapTimeout)(function () {
              return cycleRequest({
                url: url,
                options: options,
                data: data,
                retries: retries,
                delay: delay,
                retriesRemaining: newRetriesRemaining
              });
            }, delay));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function tryAgain(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var _default = sendRequest;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-sdk-web/dist/cjs/networkRequest.js
// module id = 3448
// module chunks = 11